import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import partnerInitialState from './state';
import { PartnerState } from './Interfaces/PartnerState';
import { Tag, Team } from 'generated/graphql';

const partnerSlice = createSlice({
    name: 'partner',
    initialState: partnerInitialState,
    reducers: {
        SAVE: (state, action: PayloadAction<PartnerState>) => {
            return {
                ...state,
                ...(action.payload || {}),
            };
        },
        CLEAN_PARTNER_DATA: (state) => {
            return {
                ...state,
                partnerData: null,
            };
        },
        SET_PARTNER_PRIVATE_REVIEWS: (
            state,
            action: PayloadAction<boolean>,
        ) => {
            const isPrivateReviewsEnabled = action.payload;
            return {
                ...state,
                partnerData: {
                    ...state.partnerData,
                    privateReviews: isPrivateReviewsEnabled,
                },
            };
        },
        UPDATE_SELECTED_TEAMS_ID: (state, action: PayloadAction<string[]>) => {
            const newSelectedTeamsId = action.payload;
            window.localStorage.setItem(
                'selectedTeamIds',
                JSON.stringify(newSelectedTeamsId),
            );
            return {
                ...state,
                selectedTeamsId: newSelectedTeamsId,
            };
        },
        ADD_NEW_TEAM: (state, action: PayloadAction<Team>) => {
            const newTeam = action.payload;
            return {
                ...state,
                teamsForTeamSelector: [...state.teamsForTeamSelector, newTeam],
            };
        },
        REMOVE_A_TEAM: (state, action: PayloadAction<string>) => {
            const teamId = action.payload;
            const newTeam = state.teamsForTeamSelector.filter(
                (team) => team.key !== teamId,
            );
            return {
                ...state,
                teamsForTeamSelector: newTeam,
            };
        },
        SAVE_TEAM_LEADER_BY_DEFAULT: (state, action: PayloadAction<string>) => {
            const teamLeader = action.payload;
            return {
                ...state,
                updateTeam: {
                    ...state.updateTeam,
                    teamLeaderByDefault: teamLeader,
                },
            };
        },
        SAVE_TEAM_NAME_BY_DEFAULT: (state, action: PayloadAction<string>) => {
            const teamName = action.payload;
            return {
                ...state,
                updateTeam: {
                    ...state.updateTeam,
                    teamNameByDefault: teamName,
                },
            };
        },
        SAVE_TEAMS_UPDATED: (state, action: PayloadAction<Team[]>) => {
            const teamUpdated = action.payload;
            return {
                ...state,
                teamsForTeamSelector: teamUpdated,
            };
        },
        ADD_REVIEW_TAG: (state, action: PayloadAction<Tag>) => {
            const newTag = action.payload;

            state.partnerData.approvedTags = [
                ...state.partnerData.approvedTags,
                newTag,
            ];
        },

        REMOVE_REVIEW_TAG: (state, action: PayloadAction<string>) => {
            const targetId = action.payload;

            state.partnerData.approvedTags =
                state.partnerData.approvedTags?.filter(
                    (tag) => tag.tagId !== targetId,
                ) || [];
        },

        REMOVE_ALL_PARTNER_TAGS: (state) => {
            state.partnerData.approvedTags = [];
        },

        ADD_CRM_URL: (state, action: PayloadAction<string>) => {
            const newCrm = action.payload;
            state.partnerData.CRMURL = newCrm;
        },
    },
});

export const partnerReducer = partnerSlice.reducer;
export const partnerActions = partnerSlice.actions;
